/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useNavigate } from 'react-router-dom'

import { useConfig } from '@modules/cui/ConfigContext'
import {
  organizationBillingBudgetsAndNotificationsUrl,
  organizationBillingCreateBudgetUrl,
  organizationBillingEditBudgetUrl,
} from '@modules/urls/organizations'
import useOrganizationId from '@modules/billing-lib/hooks/useOrganizationId'

import {
  billingBudgetsAndNotificationsUrl,
  billingCreateBudgetUrl,
  billingEditBudgetUrl,
} from '@/apps/userconsole/urls'

import type { Budget } from '../Budgets/types'

const useBillingNotificationsNav = () => {
  const navigate = useNavigate()
  const organizationId = useOrganizationId()

  const isAdminConsole = useConfig('APP_NAME') === 'adminconsole'

  const goToBillingNotifications = () =>
    navigate(
      isAdminConsole && organizationId
        ? organizationBillingBudgetsAndNotificationsUrl(organizationId)
        : billingBudgetsAndNotificationsUrl(),
    )

  const goToCreateBudget = () =>
    navigate(
      isAdminConsole && organizationId
        ? organizationBillingCreateBudgetUrl(organizationId)
        : billingCreateBudgetUrl(),
    )

  const goToEditBudget = ({ id }: Budget) =>
    id &&
    navigate(
      isAdminConsole && organizationId
        ? organizationBillingEditBudgetUrl(organizationId, id.toString())
        : billingEditBudgetUrl(id.toString()),
    )

  return {
    goToBillingNotifications,
    goToCreateBudget,
    goToEditBudget,
  }
}

export default useBillingNotificationsNav
